/**
 * Every paywall a path, not a sentence (ROADMAP 0.R R2): a 402 refusal
 * — a cap, a daily limit, a Strategist-only feature — also offers the plan that
 * lifts it, through the one `UpgradeOffer` mounted in the app.
 *
 * A window event rather than a store: `parseApiError` is plain code with no
 * React around it, and the listener is a single component.
 */
import type { PaidPlan } from '../services/billingService';

export const UPGRADE_EVENT = 'ia:upgrade-offer';

/** The codes a paid gate sends on a 402 (functions `_entitlements.entitlement_response`). */
export const UPSELL_CODES = new Set<string>([
  'PRICE_ALERT_CAP', 'PORTFOLIO_CAP', 'HOLDINGS_CAP', 'SHARE_CAP', 'AUTOMATION_CAP',
  'STRATEGIST_REQUIRED', 'SIGNALS_REQUIRED', 'DAILY_LIMIT', 'upgrade_required',
]);

export interface UpgradeOfferDetail { code: string; message: string }

/** The plan that lifts this refusal for a reader on `current`, or null when
 *  there is nothing above them. */
export function planToOffer(code: string, current: string | null | undefined): PaidPlan | null {
  if (code === 'STRATEGIST_REQUIRED') return current === 'strategist' ? null : 'strategist';
  if (code === 'SIGNALS_REQUIRED') return current === 'free' || !current ? 'signals' : null;
  if (!current || current === 'free') return 'signals';
  if (current === 'signals') return 'strategist';
  return null;
}

export function offerUpgrade(code: string, message: string): void {
  if (typeof window === 'undefined' || !UPSELL_CODES.has(code)) return;
  window.dispatchEvent(new CustomEvent<UpgradeOfferDetail>(UPGRADE_EVENT, { detail: { code, message } }));
}
